import React from 'react'

function Certificaciones() {
    return (
        <div className="todo_certificaciones">
            <div id="certificaciones">
                <div className="titulo_certificaciones">
                    <h3>CERTIFICACIONES</h3>
                </div>
                <div className="certificaciones">
                    <div className="certificacion">
                        <div className="titulo_certificacion">
                            The complete Javascript course 2024: From ZERO To EXPERT
                        </div>
                        <div className="certificado">
                            By Jonas Schmedtmann - 68,5h
                        </div>
                    </div>
                    <div className="certificacion">
                        <div className="titulo_certificacion">
                            CSS - The Complete Guide 2024 (incl. Flexbox, Grid & Sass)
                        </div>
                        <div className="certificado">
                            By Maximilian Schwarzmüller - 23h
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Certificaciones
